module Meevo.Plugins.TimeClock {
    class TimeClockController {

        closeContext: Function;
        context: TimeClockContext;
        resetContext: Function;

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "$http",
            "$translate",
            "$rootScope",
            "$state",
            "meevo.components.busy.BusyService",
            "meevo.components.tracking.TrackingService"
        ];

        constructor(private appSettings: Meevo.Components.Common.IAppSettings,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private modalService: Meevo.Components.Modal.IModalService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private $http: angular.IHttpService,
            private $translate: angular.translate.ITranslateService,
            protected $rootScope: angular.IRootScopeService,
            protected $state: any,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            public viewMySchedule: any) {

            let vm = this;
            vm.context = this.timeClockContext;

            vm.closeContext = (): void => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
            }

            vm.resetContext = (): void => {
                vm.context = this.timeClockContext;
            }

        }

        get timeClockContext(): TimeClockContext {
            this.context = null;
            return new TimeClockContext(this.appSettings, this.dataService, this.identityService, this.modalService, this.$http, this.$translate, this.busyService, this.trackingService);
        }
    }

    angular.module("meevo.plugins.timeClock")
        .controller("meevo.plugins.timeClock.TimeClockController", TimeClockController);
}